import e from "./ghl-ui.es1260.js";
import i from "./ghl-ui.es1261.js";
import a from "./ghl-ui.es420.js";
function t(r) {
  return a(r) ? e(r, !0) : i(r);
}
export {
  t as default
};
